
class SmsDefaultMsgModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): SmsDefaultMsgModel {
        return new SmsDefaultMsgModel(
            json["id"],
            json["title"],
            json["isActive"],
        );
    }
}


export interface SmsDefaultMsgGetPayloadFilterModel {
    id?: number;
    title?: string;
    isActive?: boolean;
}

export interface SmsDefaultMsgGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: SmsDefaultMsgGetPayloadFilterModel;
}


export interface SmsDefaultMsgPayloadModel {
    id: number;
    title: string;
    isActive: boolean;

}
export default SmsDefaultMsgModel;
